// DEV_MODE only when explicitly set — never in production builds
export const DEV_MODE = process.env.REACT_APP_DEV_MODE === 'true' && process.env.NODE_ENV !== 'production';
